export default function AgenciesController(
  $q,
  $rootScope,
  $scope,
  $filter,
  addAuditAgencyDialog,
  alerts,
  amDataService,
  amSharedModelService,
  loaderService,
  ssDialogService
) {
  const vm = this;

  vm.handleFilterTextChange = handleFilterTextChange;
  vm.handleAddAgency = handleAddAgency;
  vm.allAgenciesFiltered = false;

  _initEventListeners();

  /** *********************************************
   * Event Handlers
   */

  function handleFilterTextChange(newText) {
    vm.allAgenciesFiltered = $filter('filter')(vm.agencies, { name: newText }).length === 0;
  }

  function handleAddAgency($event) {
    _showAddAuditAgencyDialog($event);
  }

  /** *********************************************
   * Private Functions
   */

  function _initEventListeners() {
    $scope.$on('refreshAMAgencies', _refreshAgencies);
    $scope.$on('selectAMAgency', (event, opt) => { _disableSelections(opt.agency); });
    $scope.$on('deselectAMAgency', () => { _enableSelections(); });
    $scope.$on('deletedAMAgency', () => { _enableSelections(); });
  }

  function _showAddAuditAgencyDialog($event) {
    ssDialogService.dialogs.auditTrail.addAuditAgencyDialog = ssDialogService.alert(
      addAuditAgencyDialog.getOptions($event, {
        customerId: vm.audit.customerId,
        audit: vm.audit,
        agency: {
          agencyId: -1,
        },
        agencies: vm.agencies,
        auditTypes: vm.auditTypes,
        coordinators: vm.coordinators,
        objectDataTypes: vm.objectDataTypes,
        refreshAudit: false,
        addCallback: _handleAddedAgency,
        updateCallback: _handleUpdatedAgency,
      })
    );
    return ssDialogService.show(ssDialogService.dialogs.auditTrail.addAuditAgencyDialog);
  }

  function _handleAddedAgency(agency) {
    vm.agencies = vm.agencies || [];
    vm.agencies.push(agency);
    if (vm.agencies.length > 1) {
      vm.agencies = amSharedModelService.sortByName(vm.agencies);

      // Deselect the previous agency
      const prevAgency = vm.agencies.find(item => item.agencyId === vm.audit.agencyId);

      if (prevAgency) {
        prevAgency.isSelected = false;
      }

      // Select the new agency
      agency.isSelected = true;
      $rootScope.$broadcast('refreshAuditAgencies', { agency });
      $rootScope.$broadcast('selectAMAgency', { agency }); // legacy
    }
  }

  function _handleUpdatedAgency(agency) {
    $rootScope.$broadcast('selectAMAgency', { agency }); // legacy
  }

  function _disableSelections(agency) {
    vm.audit.agencyId = agency.agencyId;
    vm.audit.agency = agency;
  }

  function _enableSelections() {
    vm.audit.agencyId = 0;
    vm.audit.agency = null;
  }

  function _refreshAgencies() {
    const dfdAgencies = $q.defer();
    loaderService.showViewLoader = true;
    amDataService.getAgencies().then((response) => {
      vm.agencies = response.data.result;
      loaderService.showViewLoader = false;
      dfdAgencies.resolve();
    });

    return dfdAgencies.promise;
  }
}

AgenciesController.$inject = [
  '$q',
  '$rootScope',
  '$scope',
  '$filter',
  'addAuditAgencyDialog',
  'alerts',
  'amDataService',
  'amSharedModelService',
  'loaderService',
  'ssDialogService'
];
